// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["assets/custom-styles"], function() { return __webpack_require__("./src/js/custom-scripts.js"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/custom-styles"], function() { return __webpack_require__("./src/scss/custom-styles.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
